import {
  Add,
  PortraitSharp,
  RemoveRedEyeSharp,
  Settings,
  TextSnippet,
} from '@mui/icons-material';
import { Box, Typography } from '@mui/material';
import ButtonActionsComponent from 'components/ButtonActionsComponent';
import ButtonComponent from 'components/ButtonComponent';
import ConfirmDeleteModalComponent from 'components/ConfirmDeleteModalComponent';
import DeviceEditionComponent from 'components/DeviceEditionComponent';
import TableComponent, { IColumnProps } from 'components/TableComponent';
import { AppContext } from 'context/AppContextProvider';
import React, { useContext, useEffect, useState } from 'react';
import {
  useDeleteDeviceByIdAsync,
  useGetAllControllersByLicenseCountAsync,
  useGetDeviceByIdAsync,
} from 'services/Devices/hooks/useMutation';
import { IDeviceProps, IDeviceSimpleProps } from 'services/Devices/types';
import { IPaginationParams } from 'services/types';
import DeviceDetailsByDiscriminator from '../_components/DeviceDetailsByDiscriminator';
import BrandIcons from '../_components/BrandIcons';
import DeviceConfigModal from '../_components/DeviceConfigModal';
import { useGetControlIdDDeviceByIdAsync } from '../../../services/Devices/Recognition/Controllers/ControlId/hooks/useMutation';
import { useGetFacialControllerByIdAsync } from '../../../services/Devices/Recognition/Controllers/hooks/useMutation';
import LogsModalComponent from '../../../components/LogsComponent';
import IsOnlineComponent from '../../../components/IsOnlineComponent';
import { getStreamByEndpointAsync } from '../../../services/Events';
import { DEVICE_CONTROLLER_ENDPOINT } from '../../../services/Devices';
import DeviceLogStream from '../_components/DeviceLogStream';
import HeaderDashboard from 'pages/DashboardPageClient/_components/_ui/Header';
import { t } from 'i18next';

const ControllersPage = () => {
  const [isVisibleEditionModal, setIsVisibleEditionModal] = useState(false);
  const [isLoadingControllers, setIsLoadingControllers] =
    useState<boolean>(false);

  const [filter, setFilter] = useState<any>({
    name: '',
  });
  const [selectedDevice, setSelectedDevice] = useState<IDeviceProps>(
    {} as IDeviceProps,
  );
  const [selectedItemToDelete, setSelectedItemToDelete] =
    useState<IDeviceSimpleProps>();
  const [isVisibleDeleteItemModal, setIsVisibleDeleteItemModal] =
    useState<boolean>(false);
  const [devicePaginationParams, setDevicePaginationParams] =
    useState<IPaginationParams>({ pageNumber: 1, pageSize: 10 });
  const [isVisibleConfigModal, setIsVisibleConfigModal] =
    useState<boolean>(false);
  const { showSnackbar } = useContext(AppContext);
  const { mutateAsync: mutateGetDeviceById } = useGetDeviceByIdAsync();
  const [logModal, setLogModal] = useState<{
    isVisible: boolean;
    deviceId: number;
  }>({ isVisible: false, deviceId: 0 });
  const [devices, setDevices] = useState<IDeviceSimpleProps[]>([]);
  const [devicesCount, setDevicesCount] = useState<number>(0);

  const columns: IColumnProps[] = [
    { label: 'Ref.', align: 'center', id: 'id', width: 0 },
    {
      label: t('common.name'),
      id: 'id',
      render(value, rowIndex) {
        const searched = devices.find((v) => v.id == Number.parseInt(value));
        if (searched) {
          return (
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.3 }}>
              <IsOnlineComponent
                width={18}
                height={18}
                isOnline={Boolean(searched.isOnline)}
              />
              {searched.name}
            </Box>
          );
        }
        return <></>;
      },
    },
    { label: t('common.model'), id: 'model' },
    {
      label: t('common.brand'),
      width: 0,
      align: 'center',
      id: 'brand',
      render(val: any) {
        return <BrandIcons brand={val} />;
      },
    },
    {
      id: 'id',
      label: t('common.actions'),
      align: 'center',
      width: 0,
      render: (id) => (
        <ButtonActionsComponent
          isWithDefaultOptionsList
          actionOptions={actionOptions(Number(id))}
          handleDelete={() => handleDeleteItem(Number(id))}
          handleEdit={() => handleEdit(Number(id))}
        />
      ),
    },
  ];

  const {
    mutateAsync: mutateDeleteDeviceById,
    isLoading: isLoadingDeleteDeviceById,
  } = useDeleteDeviceByIdAsync();

  const actionOptions = (id: number) => {
    return [
      {
        label: t('actionsOptions.configuration'),
        icon: <Settings />,
        onClick: () => {
          setIsVisibleConfigModal(true);
          handleConfig(id);
        },
      },
      {
        label: 'Logs',
        icon: <TextSnippet />,
        onClick: () => {
          setLogModal({ isVisible: true, deviceId: id });
        },
      },
    ];
  };

  const brands: any[] = [
    { label: 'Intelbras', value: 'INTELBRAS' },
    { label: 'Control ID', value: 'CONTROLID' },
    { label: 'Hikvision', value: 'HIKVISION' },
    { label: 'TopData', value: 'TOPDATA' },
  ];

  const { mutateAsync: mutateGetAllControllersCount } =
    useGetAllControllersByLicenseCountAsync();

  const { mutateAsync: mutateGetControlIdDDeviceByIdAsync } =
    useGetControlIdDDeviceByIdAsync();

  const { mutateAsync: mutateGetFacialControllerByIdAsync } =
    useGetFacialControllerByIdAsync();

  const handleConfig = async (id: number) => {
    const dev = devices.find((v) => v.id === id);
    if (dev) {
      switch (dev.discriminator) {
        case 'FacialControllerEntity':
          await mutateGetFacialControllerByIdAsync(dev.id).then((val) => {
            val.discriminator = 'FacialControllerEntity';
            setSelectedDevice(val);
          });
          break;
        case 'ControlIdDeviceEntity':
          await mutateGetControlIdDDeviceByIdAsync(dev.id).then((val) => {
            val.discriminator = 'ControlIdDeviceEntity';
            setSelectedDevice(val);
          });
          break;
        default:
          console.warn('Discriminator não tratado:', dev.discriminator);
      }
    }
    setIsVisibleConfigModal(true);
  };

  const handleCancelDeletion = () => {
    setIsVisibleDeleteItemModal(false);
    setSelectedItemToDelete(undefined);
  };

  const handleDeleteItem = async (id: number) => {
    const device: any = await mutateGetDeviceById(id);
    setSelectedItemToDelete(device);
    setIsVisibleDeleteItemModal(true);
  };

  const handleEdit = (id: number) => {
    mutateGetDeviceById(id).then(setSelectedDevice);
    setIsVisibleEditionModal(true);
  };

  const handleConfirmDeletion = () => {
    if (selectedItemToDelete?.id)
      mutateDeleteDeviceById(selectedItemToDelete?.id).then(() => {
        setDevicePaginationParams((oldStt) => ({ ...oldStt, pageNumber: 1 }));
        setIsVisibleDeleteItemModal(false);
        showSnackbar('Controlador excluído com sucesso.', 'success');
        getDevices(devicePaginationParams);
      });
  };

  const additionalButton = (
    <ButtonComponent
      startIcon={<Add />}
      size="small"
      onClick={() => setIsVisibleEditionModal(true)}
    >
      {t('controllersPage.addController')}
    </ButtonComponent>
  );

  const getDevices = (pagination: IPaginationParams) => {
    getStreamByEndpointAsync(
      DEVICE_CONTROLLER_ENDPOINT,
      setDevices,
      devicePaginationParams,
      undefined,
      setIsLoadingControllers,
      undefined,
      true,
      filter,
    );
    mutateGetAllControllersCount({ filter }).then(setDevicesCount);
  };

  useEffect(() => {
    getDevices(devicePaginationParams);
  }, [devicePaginationParams]);

  return (
    <>
      <HeaderDashboard></HeaderDashboard>
      <TableComponent
        title={
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <PortraitSharp color="success" />
            <Typography fontSize={19}>{t('controllersPage.title')}</Typography>
          </Box>
        }
        expandedRowContent={(row: any) => <DeviceLogStream deviceId={row.id} />}
        columns={columns}
        isExpandedRow
        totalCount={devicesCount}
        onChangePageOrRowsPerPage={(param) => {
          setDevicePaginationParams(param);
          getDevices(param);
        }}
        onSubmitMainFilter={() => getDevices(devicePaginationParams)}
        onChangeMainFilter={(val) =>
          setFilter((oldSt: any) => ({ ...oldSt, name: val }))
        }
        rows={devices}
        additionalTitleComponent={additionalButton}
      />

      <DeviceEditionComponent
        isOpen={isVisibleEditionModal}
        deviceToEdit={selectedDevice}
        isControllers
        handleSaveForms={(_, reset) => {
          getDevices(devicePaginationParams);
          setIsVisibleEditionModal(false);
          setSelectedDevice({} as IDeviceProps);
          reset();
        }}
        setDeviceToEdit={setSelectedDevice}
        discriminator={selectedDevice?.discriminator}
        availableEvents={
          DeviceDetailsByDiscriminator(selectedDevice?.discriminator)
            ?.availableEvents ?? []
        }
        setIsOpen={setIsVisibleEditionModal}
        brands={brands}
      />

      <LogsModalComponent
        deviceId={logModal.deviceId}
        isVisible={logModal.isVisible}
        setIsVisible={(state) =>
          setLogModal((oldStt) => ({ ...oldStt, isVisible: state }))
        }
      />

      <DeviceConfigModal
        discriminator={selectedDevice?.discriminator}
        isOpen={isVisibleConfigModal}
        selectedDevice={selectedDevice}
        setSelectedDevice={setSelectedDevice}
        setIsOpen={setIsVisibleConfigModal}
      />

      <ConfirmDeleteModalComponent
        isLoading={isLoadingDeleteDeviceById}
        isVisibleDeleteDialog={isVisibleDeleteItemModal}
        setIsVisibleDeleteDialog={setIsVisibleDeleteItemModal}
        title={'Excluir Dispositivo'}
        message={`Tem certeza que deseja excluir o controlador "${selectedItemToDelete?.name}"?`}
        handleCancelDeletion={handleCancelDeletion}
        handleConfirmDeletion={handleConfirmDeletion}
      />
    </>
  );
};

export default ControllersPage;
